import { useStorage } from '@vueuse/core';

import { computed, onMounted } from 'vue';

export function useAppVersion() {
  const currentVersion = useStorage('latest-version', '');
  const latestVersion = useStorage('app-version', '');

  const isCurrentVersion = computed(() => currentVersion.value === latestVersion.value);

  function updateVersion() {
    currentVersion.value = latestVersion.value;
  }

  async function fetchVersion() {
    try {
      const response = await fetch('/version.json');

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = (await response.json()) as { version: string };
      const latest = data.version;

      latestVersion.value = latest;
    } catch (error) {
      console.error('Błąd podczas sprawdzania wersji aplikacji:', error);
    }
  }

  onMounted(() => {
    fetchVersion();
    setInterval(() => fetchVersion(), 60000);
  });

  return { isCurrentVersion, updateVersion };
}
